import React from "react"

import { Gallery } from "@components/main/flexible-content-blocks/gallery/Gallery"
import { RichText } from "@components/main/flexible-content-blocks/rich-text/RichText"

import * as s from "./Clamp.module.scss"

export const Clamp = ({ data }) => {
  return (
    <div className={s.Clamp}>
      <div className={s.Inner}>
        <div className={s.Clamp__text}>
          <div className={s.StickyElement}>
            <RichText data={{ richText: data.text }} />
          </div>
        </div>

        <div className={s.Clamp__gallery}>
          <Gallery data={{ media: data.media, type: "flat" }} />
        </div>
      </div>
    </div>
  )
}
